<template>
	<AppDialog closeRight="-25" closeTop="-30" ref="dialog_container" :dialogName="'PrivacyAndSecurityDialog'">
		<div class="content-container display-flex flex-column">
			<div class="popup-title mb-4">{{ title }}</div>
			<div class="description-text">Here are some answers to questions you might have:</div>
			<div class="section-title mt-9 mb-2">Can I trust you guys?</div>
			<div class="description-text">
				Yes. Ply is privacy focused and security obsessed. <br />
				We're also compliant with some of the strictest security and privacy standards out there.
			</div>
			<div class="badges-container flex-centerize width-100 mt-7 mb-9">
				<v-img class="badge" :src="GDPRIcon" />
				<v-img class="badge" :src="CSAIcon" />
				<v-img class="badge" :src="CyberIcon" />
			</div>
			<div class="badges-explanation-container mb-8">
				Under review for SOC2 type 2 and ISO27001, expected to complete by the end of January 2023
			</div>
			<div class="section-title mt-2 mb-3">What's the extension for?</div>
			<div class="description-text">
				The extension lets Ply add buttons to your apps, access the data needed to make features work, and present interfaces. It also lets
				you manage and build your own features.
			</div>

			<div class="display-flex flex-row flex-align-center privacy-text mt-4">
				We never sale or share your data. Read more in our
				<a class="ml-1 privacy-text" target="_blank" href="https://info.ply.io/privacy">privacy policy </a>
			</div>

			<div v-if="skipExtensionMode" class="display-flex flex-column width-100 flex-centerize mt-9">
				<AnemicButton class="chrome-store-button mt-9" @click="downloadExtension">
					<SIcon name="chrome" class="mr-2 mt-1" />
					Go to the Chrome Store
				</AnemicButton>
				<div class="skip-text mt-5" @click="skip">Continue without the extension</div>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import CSAIcon from '@/assets/icons/csa.png';
import GDPRIcon from '@/assets/icons/gdpr.png';
import CyberIcon from '@/assets/icons/cyber.png';
export default {
	name: 'PrivacyAndSecurityDialog',
	props: {
		onSkip: { type: Function },
		goToChromeStore: { type: Function },
		skipExtensionMode: { type: Boolean },
	},
	components: {
		AppDialog,
	},
	computed: {
		title() {
			return this.skipExtensionMode ? 'Without the extension, you won’t be able to add features to your apps.' : 'Privacy and security';
		},
	},
	methods: {
		closeDialog() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		skip() {
			this.closeDialog();
			this.onSkip();
		},
		downloadExtension() {
			this.closeDialog();
			this.goToChromeStore();
		},
	},
	data() {
		return {
			CSAIcon,
			GDPRIcon,
			CyberIcon,
		};
	},
};
</script>

<style scoped lang="scss">
.content-container {
	min-width: 696px;
	max-width: 696px;
	min-height: 580px;
	max-height: 680px;
	margin-left: -28px;
	border-radius: 10px;
	background: var(--bg-color);
	padding: 40px 14px 17px 30px;
	box-shadow: 0px 3px 6px var(--shadow-color);

	.popup-title {
		font-size: 20px;
		font-weight: bold;
		color: var(--primart-font-color);
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: var(--primart-font-color);
	}

	.description-text {
		font-size: 14px;
		font-weight: normal;
		color: var(--signup-grey);
	}
}

.badges-container {
	height: 148px;
	border-radius: 38px;
	background: var(--header-background);

	.badge {
		max-width: 82px;
		max-height: 82px;
	}
}
.chrome-store-button {
	height: 45px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bg-color);
	border: 1px solid var(--bg-color);
	background: var(--bold-border-color) !important;
}
.skip-text {
	cursor: pointer;
	font-size: 14px;
	text-decoration: underline;
	color: var(--bold-border-color);
}
.privacy-text {
	font-size: 14px;
	color: var(--primart-font-color);
}
.badges-explanation-container {
	font-weight: 500;
	font-size: 14px;
	color: var(--primart-font-color);
	margin-top: -60px;
	text-align: center;
}
</style>
